/** Shared browser helpers: authed JSON POST + status messages. */

export function getCsrfToken(): string {
  const meta = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]');
  if (!meta?.content) throw new Error('Missing CSRF token on the page.');
  return meta.content;
}

export async function postJson<TRes>(url: string, body?: unknown): Promise<TRes> {
  const res = await fetch(url, {
    method: 'POST',
    headers: { 'content-type': 'application/json', 'x-csrf-token': getCsrfToken() },
    body: body === undefined ? undefined : JSON.stringify(body),
    credentials: 'same-origin',
  });

  let data: { error?: string } = {};
  try {
    data = (await res.json()) as { error?: string };
  } catch {
    /* empty body is fine */
  }
  if (!res.ok) throw new Error(data.error ?? `Request failed (${res.status})`);
  return data as TRes;
}

export function setStatus(el: HTMLElement | null, message: string, kind: 'info' | 'error' | 'success' = 'info'): void {
  if (!el) return;
  el.textContent = message;
  el.classList.remove('error', 'success');
  if (kind !== 'info') el.classList.add(kind);
}
